(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/pix-mix/components/pix-mix-container/assets/javascripts/pix-mix-container.js') >= 0) return;  svs.modules.push('/modules/pix-mix/components/pix-mix-container/assets/javascripts/pix-mix-container.js');

'use strict';

const {
  useState,
  useEffect
} = React;
const WidgetArea = svs.components.lbUtils.widgetArea.WidgetArea;
const {
  MALTIPSET,
  STRYKTIPSET,
  T8,
  T8EXTRA,
  T8STRYK
} = svs.utils.products.productIds;
const {
  PixmixView,
  PixMixClosed,
  PixMixSkeleton
} = svs.pix_mix.components.pixmixView;
const {
  CampaignFlerp
} = svs.components.lbUi.campaignFlerp;
const logger = new svs.core.log.Logger('svs.pix_mix.Pixmixen');
const {
  fetchDraws
} = svs.pix_mix.components.services;
const PixmixContainer = () => {
  const [draws, setDraws] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const fetchDrawsAndRefresh = () => {
    fetchDraws(response => {
      setDraws(response);
      setIsLoading(false);
    }, () => {
      setIsLoading(false);
    });
  };
  useEffect(() => {
    fetchDrawsAndRefresh();
  }, []);

  const hasActiveDrawsForProducts = () => {
    const productsFromDraws = draws.map(draw => draw.productId);
    const topptipsetProductIds = [T8, T8EXTRA, T8STRYK];
    const maltipsetActive = productsFromDraws.includes(MALTIPSET);
    const stryktipsetActive = productsFromDraws.includes(STRYKTIPSET);
    const topptipsetActive = topptipsetProductIds.filter(id => productsFromDraws.includes(id)).length > 0;
    logger.info("verifyActiveDrawsForProducts:\n      ".concat(maltipsetActive ? '✅' : '❌', " M\xE5ltipset\n      ").concat(stryktipsetActive ? '✅' : '❌', " Stryktipset\n      ").concat(topptipsetActive ? '✅' : '❌', " Topptipset\n    "));
    const hasActiveDraws = maltipsetActive && stryktipsetActive && topptipsetActive;
    return hasActiveDraws;
  };
  const PixMixComponentWrapper = () => {
    if (isLoading) {
      return React.createElement(PixMixSkeleton, null);
    } else if (hasActiveDrawsForProducts()) {
      return React.createElement(PixmixView, {
        className: "pix-mix-content",
        draws: draws,
        refreshDraws: fetchDrawsAndRefresh
      });
    }
    return React.createElement(PixMixClosed, {
      className: "pix-mix-content"
    });
  };
  return React.createElement(React.Fragment, null, React.createElement(CampaignFlerp, null), React.createElement(WidgetArea, {
    className: "pix-mix-widget-area pix-mix-before-widget-area",
    widgetArea: "pixmixBeforeWidgetArea"
  }), React.createElement("section", {
    className: "pix-mix-container"
  }, React.createElement(PixMixComponentWrapper, null)), React.createElement(WidgetArea, {
    className: "pix-mix-widget-area pix-mix-after-widget-area",
    widgetArea: "pixmixAfterWidgetArea"
  }));
};
setGlobal('svs.pix_mix.components.PixmixContainer', PixmixContainer);

 })(window);